/**
 * @file upp-konva-host-group.ts
 * English comment normalized.
 *
 * English comment normalized.
 * English comment normalized.
 */

import type { UppFloorPlanStageComponent } from '../canvas/upp-floor-plan-stage.component';
import type { UppKonvaFloorPlanModel } from '../internal/upp-konva-floor-plan-model';
import { UppKonvaFloorPlanGroup } from '../presentation/upp-konva-floor-plan-group';
import { uppKonvaSceneModelHost } from '../internal/upp-konva-scene-model-host';

/**
 * English comment normalized.
 *
 * @param model Instancia {@link UppKonvaFloorPlanModel} cableada al host.
 * English comment normalized.
 */
export function emitUppKonvaGroupedFromStage(
  model: UppKonvaFloorPlanModel,
  floor: UppFloorPlanStageComponent | undefined,
): void {
  if (!floor) {
    return;
  }
  const sel = floor.getSelection();
  uppKonvaSceneModelHost(model).notifyGrouped(
    sel.length >= 2 ? new UppKonvaFloorPlanGroup(floor, model) : null,
  );
}
